import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { fDate } from 'src/utils/format/format-time';

import { Image } from 'src/components/image';

import { summarizeBlogPost } from '../utils/blog-post-json-ld';
import { CM, clampLines, PUBLIC_TEXT, BLOG_CARD_LINK_SX, BLOG_COVER_FRAME_SX, BLOG_COVER_IMAGE_SX } from '../constants/blog-layout';

import type { BlogPost } from '../scope/blog-post-scope';

// ----------------------------------------------------------------------

type PostItemProps = {
  post: BlogPost;
  detailsHref: string;
};

/**
 * 글 카드 한 장 — 표지 · 첫 주제 · 제목(두 줄) · 요약(두 줄) · 날짜. 카드 전체가 글로 가는 링크다.
 * 🔑 테두리·그림자 없이 흰 바탕에 선다 — 표지가 덩어리를 만든다(공개 지면에 떠 있는 판은 목업 하나뿐).
 */
export function PostItem({ post, detailsHref }: PostItemProps) {
  const topic = post.tags?.[0];

  return (
    <Box
      component={RouterLink}
      href={detailsHref}
      sx={BLOG_CARD_LINK_SX}
    >
      <Box sx={BLOG_COVER_FRAME_SX}>
        <Image
          alt={post.title}
          src={post.coverUrl}
          ratio="16/9"
          sizes="(min-width: 900px) 360px, (min-width: 600px) 50vw, 100vw"
          sx={BLOG_COVER_IMAGE_SX}
        />
      </Box>

      {topic && <Typography sx={{ ...PUBLIC_TEXT.eyebrow, color: CM.primary, mt: 1.5 }}>{topic}</Typography>}

      <Typography
        component="h3"
        className="blog-card-title"
        sx={{ ...PUBLIC_TEXT.subtitle, fontSize: PUBLIC_TEXT.subtitle.fontSize.xs, color: CM.textDark, mt: topic ? 0.5 : 1.5, ...clampLines(2) }}
      >
        {post.title}
      </Typography>

      <Typography sx={{ ...PUBLIC_TEXT.body, color: CM.textMuted, mt: 0.5, ...clampLines(2) }}>
        {summarizeBlogPost(post)}
      </Typography>

      <Typography sx={{ fontSize: PUBLIC_TEXT.eyebrow.fontSize, color: CM.textSubtle, mt: 1 }}>{fDate(post.createdAt)}</Typography>
    </Box>
  );
}
